import { QRCodeCanvas } from "qrcode.react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppServices } from "../../../../../../hook/services";

const AssignUserSimModal = ({ user, handleRefresh }) => {
  const AppService = useAppServices();
  const { locationId, companyId } = useParams();
  const [open, setOpen] = useState(false);
  const [availableSims, setAvailableSims] = useState([]);
  const [selectedSimId, setSelectedSimId] = useState("");
  const [loading, setLoading] = useState(false);
  const [assigning, setAssigning] = useState(false);

  const hasExistingSim =
    user?.assigned_sim_id || user?.sim_id || user?.current_sim;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fetchAvailableSims = async () => {
    setLoading(true);
    try {
      const { response } = await AppService.sim.assignable_sim_ByLocationId({
        query: `locationId=${locationId}`,
      });
      setAvailableSims(response?.data || []);
    } catch (error) {
      console.error("Error fetching SIMs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableSims();
  }, []);

  const handleAssignSim = async () => {
    if (!user) return;

    setAssigning(true);
    const simIdToAssign =
      selectedSimId === "null" || selectedSimId === "" ? null : selectedSimId;

    try {
      const payload = {
        userId: user.id,
        simId: simIdToAssign,
      };
      const { response } = await AppService.user.assignSim({ payload });

      if (response) {
        await handleRefresh();
        handleClose();
        fetchAvailableSims();
        // console.log("SIM assigned to user successfully");
      }
    } catch (error) {
      console.error("Error assigning SIM to user:", error);
      throw error;
    } finally {
      setAssigning(false);
    }
  };

  return (
    <>
      {/* Modal */}
      <button
        type="button"
        className="btn btn-primary px-4 py-2 rounded-3 shadow-sm"
        style={{ fontSize: "0.875rem" }}
        onClick={handleOpen}
      >
        <i className="bi bi-sim me-2"></i>
        {user?.connectedSim ? "Manage SIM" : "Assign SIM"}
      </button>
      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              {/* Header */}
              <div className="modal-header border-bottom-0 pb-0">
                <h5 className="modal-title fw-bold text-dark">
                  <i className="bi bi-sim me-2 text-primary" />
                  Assign SIM
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                  disabled={assigning}
                ></button>
              </div>

              {/* Body */}
              <div className="modal-body pt-2">
                {user && (
                  <div className="mb-4">
                    <p className="text-muted mb-2">Assigning SIM to:</p>
                    <div className="d-flex align-items-center p-3 bg-light rounded-3">
                      <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                        <i className="bi bi-person text-primary" />
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-0 fw-semibold text-dark">
                          {user.username}
                        </h6>
                        <small className="text-muted">{user.email}</small>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mb-4">
                  <label
                    htmlFor="simSelect"
                    className="form-label fw-semibold text-dark"
                  >
                    Select Available SIM
                  </label>

                  {loading ? (
                    <div className="d-flex justify-content-center py-3">
                      <div
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading SIMs...</span>
                      </div>
                    </div>
                  ) : availableSims ? (
                    <select
                      id="simSelect"
                      className="form-select border-2 rounded-3"
                      style={{ borderColor: "#E1E5E9" }}
                      value={selectedSimId}
                      onChange={(e) => setSelectedSimId(e.target.value)}
                      disabled={assigning}
                    >
                      <option value="">Choose a SIM...</option>
                      {user?.connectedSim && (
                        <option value="null">Remove SIM</option>
                      )}
                      {availableSims?.map((sim) => (
                        <option key={sim._id} value={sim._id}>
                          {sim.sim_number}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <div className="text-center py-4">
                      <i className="bi bi-sim display-6 text-muted opacity-50" />
                      <p className="text-muted mt-2 mb-0">
                        No available SIMs found
                      </p>
                      <small className="text-muted">
                        All SIMs are currently assigned
                      </small>
                    </div>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer border-top-0 pt-0">
                <button
                  type="button"
                  className="btn btn-primary px-4 py-2 rounded-3 shadow-sm"
                  onClick={handleAssignSim}
                  disabled={
                    assigning ||
                    loading ||
                    (selectedSimId === "" && !hasExistingSim)
                  }
                >
                  {assigning ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle me-2"></i>
                      {selectedSimId === "null" ? "Remove SIM" : "Assign SIM"}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssignUserSimModal;
